import React from 'react';
import { interpolateReds, interpolatePuBu, interpolateCividis, interpolateTurbo } from 'd3';
import config from '../../config';
import PieChart from '../PieChart';
import { toDegC } from '../../utils';
import { BLACK } from '../../style';
import DoughnutText from '../DoughnutText';


const MAX_TEMP = config.sensors.temp.max;
const MIN_TEMP = config.sensors.temp.min;

/*
  Bit of a weird set up but these render functions map to the sensor keys provided by the api
  and passed to Nodes plot so can easily configure the data shown by passing a list of keys
*/
export const temp_last = degF => {
  const temp = toDegC(degF);
  return (
    <g>
      <PieChart
        value={temp}
        max={MAX_TEMP}
        min={MIN_TEMP}
        colors={[interpolateTurbo(temp/MAX_TEMP), 'lightgrey']}
      />
      <text alignmentBaseline="middle" transform={`translate(26, 0)`} fill={BLACK}>
        {`${temp.toFixed(1)}ºC`}
      </text>
    </g>
  )
}

export const temp_out = temp_last;

// Scale 0 - 15, no units given
export const wetness_last = wetness => {
  const percentage = Math.floor((wetness / 15) * 100)
  return (
    <DoughnutText
      label="LEAF"
      value={wetness}
      max={15}
      text={`${percentage}%`}
      color={interpolatePuBu(percentage / 100)}  
    />
  )
}

export const moist_soil_last = moistness => (
  <DoughnutText
    label="SOIL"
    value={moistness}
    text={`${moistness}%`}
    color={interpolatePuBu(moistness / 100)}  
  />
)

export const rain_day_mm = rain => (
  <text>{`🌧️ ${rain}mm`}</text>
)

export const hum_last = hum => (
  <g>
    <PieChart
      value={hum}
      colors={[interpolatePuBu(hum / 100), 'lightgrey']}
    />
    <text alignmentBaseline="middle" transform={`translate(26, 0)`} fill={BLACK}>
      {`${hum.toFixed(0)}%`}
    </text>
  </g>
)

export const hum_out = hum_last;

export const solar_rad_last = rad => (
  <text fill={interpolateCividis(rad / 1)}>
    {`☀️${rad}W/m²`}
  </text>
)

export const solar_rad = solar_rad_last;

export const wind_speed_last = speed => (
  <text  >{`${speed}mph`}</text>
)

export const wind_speed = wind_speed_last;

// TODO: Combine with speed by having Nodes pass all the values through as second arg
export const wind_dir_last_deg = wind_dir => {
  const transform = `rotate(${wind_dir})`;
  const speed = 20;
  return (
    <g
      transform={transform}>
      <path
        d={`M0 0 L0 -${speed}`}
        stroke="blue"
        stroke-width={2}
        fill="none"  
      />
      <polygon
        points={`-2,-${speed - 4} 0,-${speed} 2,-${speed - 4}`}
        stroke="blue"
        stroke-width={1}
        fill="blue"  
      />
    </g>
  )
}

export const wind_dir = wind_dir_last_deg;

export const wet_bulb_last = degF => {
  const temp = toDegC(degF);
  return (
    <g>
      <DoughnutText
        value={temp}
        max={config.sensors.globeTemp.max}
        min={config.sensors.globeTemp.min}
        color={interpolateTurbo(temp/config.sensors.globeTemp.max)}
        label="GLOBE"
        text={`${temp.toFixed(1)}ºC`}
      />
    </g>
  )
}

export const heat_index = wet_bulb_last;

export const generic = key => value => <text >{`${key}: ${value}`}</text>



// WEBPACK FOOTER //
// ./src/components/sensors/index.js